<template>
	<div class="fraction-component">
		<template v-if="simplification">
			<div class="simplification fraction" :is="fraction"></div>
		</template>
		<template v-else-if="isMixed">
			<span>{{ read_notation(fract.intVal) }}<fraction v-if="fract.num % fract.den != 0" :fraction="{num: fract.num % fract.den, den: fract.den}" /></span>
		</template>
		<div class="fraction" v-else>
			<div class="numerator-fraction" v-if="fract.num" :is='component(fract.num)'> </div>
			<!-- <input type="text" name="" v-model="fract.num" v-else-if="" @keydown="restrictKeys" class="form-control mb-1" placeholder="Numerator"> -->
			<div class="separator-fraction"></div>
			<div class="denominator-fraction" v-if="fract.den" :is='component(fract.den)'> </div>
			<!-- <input type="text" name="" v-model="fract.den" v-else @keydow="restrictKeys" class="form-control mt-1" placeholder="Denominator"> -->
		</div>
	</div>
</template>

<script>
	 import Fraction from './scripts/Fraction';
	 const $functions = require('./scripts/functions');
	export default{
		props:{
			fraction: {type: [Object, Array, Number, String], required: false},
			inputNum: {type: [Boolean, Number], required: false, default: false},
			inputDen: {type: [Boolean, Number], required: false, default: false},
			simplification: {type: [Boolean], required: false, default: false},
			mixed: {type: Boolean, default: false}
		},
		name: 'fraction',
		data(){
			return{
				denominator: "",
				numerator: "",
				fract: {},
			}
		},
		methods:{
			component(str){
				return {template:$functions.tag('span', str, {class: ''})}
			},
		},
		created(){
			if(this.simplification){
				this.fract = Object.assign({}, this.fraction);
			}else{
				this.fract = this.fraction instanceof Array ? new Fraction(...this.fraction) : new Fraction(this.fraction);
			}
		},
		computed: {
			isMixed() {
				return this.mixed && this.fract.intVal > 0;
			}
		}
	};
</script>

<style lang="scss" scoped>
	.fraction-component{
		display: inline-block;
		vertical-align: middle;
		text-align: center;
		margin-right: 0 0.25rem;
		.numerator-fraction{
			text-align: center!important;
			margin-bottom:-0.25rem;
		}
		.separator-fraction{
			border-bottom:1px solid grey;
		}
		.denominator-fraction{
			margin-top:-0.25rem;
			text-align: center!important;
		}
		input{
			text-align: center;
		}
	}
</style>